"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SponsoredMohole = void 0;
var Tags_1 = require("../Tags");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var Units_1 = require("../../Units");
var SponsoredMohole = (function (_super) {
    __extends(SponsoredMohole, _super);
    function SponsoredMohole() {
        return _super.call(this, {
            cost: 5,
            tags: [Tags_1.Tags.BUILDING],
            name: CardName_1.CardName.SPONSORED_MOHOLE,
            cardType: CardType_1.CardType.AUTOMATED,
            productionBox: Units_1.Units.of({ heat: 2 }),
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.party(PartyName_1.PartyName.KELVINISTS); }),
            metadata: {
                cardNumber: 'T13',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.heat(2); });
                }),
                description: 'Requires that Kelvinists are ruling or that you have 2 delegates there. Increase your heat production 2 steps.',
            },
        }) || this;
    }
    SponsoredMohole.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.HEAT, 2);
        return undefined;
    };
    return SponsoredMohole;
}(Card_1.Card));
exports.SponsoredMohole = SponsoredMohole;
